import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./Tuberculosis.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getDiseaseDetails } from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const Tuberculosis = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector((state: RootState) => state.info.diseaseDetails);
  const params = useParams();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getDiseaseDetails(Number(params.id)));
  }, [dispatch, params]);
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Что делать, если выявили туберкулез на медосмотре в России "
        description="Можно ли остаться в России мигрантам с туберкулезом, как избежать запрета на въезд, что такое реестр контролируемых лиц и где получить лечение."
        url="https://www.vputi.org/russia/tuberculosis/3"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / Туберкулёз",
            path: "/russia",
          }}
        />
        <ContactButtons />
        <div className={s.inner}>
          <div className={s.text}>
            <div className={s.text_title}>{disease?.title_1}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
            ></div>
          </div>
          <div className={s.buttons}>
            {
              <Link
                to={"/russia/pre-departure/tuberculosis/3"}
                className={s.button}
              >
                {t("Для мигрантов с диагнозом туберкулез")}
              </Link>
            }
          </div>

          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>

          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Tuberculosis;
